import React from "react";
import { Link } from "react-router-dom";
import SectionLayout from "@/pages/SectionLayout";

/**
 * Architecture — Intro page.
 * Sequence: /architecture → /architecture/blueprint → /architecture/engine → /architecture/world → /lets-talk
 *
 * The intro now uses the title "ARCHITECTURE" itself. The first service
 * (formerly "AI Readiness & Strategic Consulting", now "The Blueprint")
 * lives on its own dedicated page and is reached via the next-button below.
 */
const Architecture = () => {
  return (
    <SectionLayout>
      <h2 className="glass-panel__title" data-testid="section-title">
        ARCHITECTURE
      </h2>
      <p className="glass-panel__body" data-testid="section-body">
        Our architectural process serves as the vital bridge between
        high-end marketing strategy and deep technical automation. We
        approach systems engineering with the exact same philosophy a
        director applies to cinema: the underlying technology must remain
        entirely invisible, ensuring that the narrative itself is the only
        thing your client ever perceives.
      </p>
      <div className="glass-panel__nav">
        <Link to="/" className="glass-panel__btn" data-testid="btn-home">
          Home
        </Link>
        <Link
          to="/architecture/blueprint"
          className="glass-panel__btn glass-panel__btn--right"
          data-testid="btn-next"
        >
          The Blueprint
        </Link>
      </div>
    </SectionLayout>
  );
};

export default Architecture;
